import {
  fundingOrderMap,
  fundingSource,
  getSelectedSources,
  getUnselectedSources,
} from './fundingSourcesAssets'

const placeholderMap = ['buttons']

export const htmlFundingSources = (fundingSources: string[]) => {
  let buttons = ''
  fundingSources
    .filter((funding) => fundingSource[funding])
    .forEach((funding) => {
      buttons += `
        paypal.Buttons({
        fundingSource: '${fundingSource[funding]}',
        
        style: {
          layout: '{{ buttonLayout }}',
          shape: '{{ buttonStyle }}',
        }
      
        createOrder: async (data, actions) => {
          const response = await fetch("/orders", {
            method: "POST",
          });
          const details = await response.json();
          return details.id;
        },
        onApprove: async (data, actions) => {
          const response = await fetch(\`/orders/\${data.orderID}/capture\`, {
            method: "POST",
          });
          const details = await response.json();
          // Three cases to handle:
          //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
          //   (2) Other non-recoverable errors -> Show a failure message
          //   (3) Successful transaction -> Show confirmation or thank you
      
          // This example reads a v2/checkout/orders capture response, propagated from the server
          // You could use a different API or structure for your 'orderData'
      
          const errorDetail = Array.isArray(details.details) && details.details[0];
          if (errorDetail && errorDetail.issue === 'INSTRUMENT_DECLINED') {
            return actions.restart(); // Recoverable state, per:
            // https://developer.paypal.com/docs/checkout/integration-features/funding-failure/
          }
      
          if (errorDetail) {
            let msg = 'Sorry, your transaction could not be processed.';
            if (errorDetail.description) msg += '\n\n' + errorDetail.description;
            if (details.debug_id) msg += ' (' + details.debug_id + ')';
            return alert(msg); // Show a failure message (try to avoid alerts in production environments)
          }
      
          // Successful capture! For demo purposes:
          console.log('Capture result', details, JSON.stringify(details, null, 2));
          const transaction = details.purchase_units[0].payments.captures[0];
          alert('Transaction '+ transaction.status + ': ' + transaction.id + '\n\nSee console for all available details');
        },
      })
      .render("#paypal-button-container");
        `
    })
  return buttons
}

export const orderSubscriptionCode = (
  method: string,
  tabs: number = 2,
  language: 'html' | 'react' | 'angular' = 'html',
) => {
  let buttons = ``

  if (method === 'recurring') {
    switch (language) {
      case 'react':
        buttons += `
${'  '.repeat(tabs)}createSubscription={ async (data, actions) => {
${'  '.repeat(tabs)}  return actions.subscription.create({
${'  '.repeat(tabs)}    plan_id: "P-3RX065706M3469222L5IFM4I",
${'  '.repeat(tabs)}  });
${'  '.repeat(tabs)}};
`
        break
      default:
        buttons += `
${'  '.repeat(tabs)}createSubscription: (data, actions) => {
${'  '.repeat(tabs)}  return actions.subscription.create({
${'  '.repeat(tabs)}    plan_id: "P-3RX065706M3469222L5IFM4I",
${'  '.repeat(tabs)}  });
${'  '.repeat(tabs)}};
`
        break
    }
  }

  return buttons
}

export const reactFundingSources = (fundingSources: string[]) => {
  let buttons = ''
  fundingSources.forEach((funding) => {
    buttons += `          <PayPalButtons
                  fundingSource='${fundingSource[funding]}'
    
                  style={{
                    layout: '{{ buttonLayout }}',
                    shape: '{{ buttonStyle }}'
                  }}
                  createOrder={async (data, actions) => {
                    const response = await fetch("http://localhost:9597/orders", {
                      method: "POST"
                    });
                    const details = await response.json();
                    return details.id;
                  }}
                  onApprove={async (data, actions) => {
                    const response = await fetch(\`http://localhost:9597/orders/\${data.orderID}/capture\`, {
                      method: "POST"
                    });
                    const details = await response.json();
                    // Three cases to handle:
                    //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                    //   (2) Other non-recoverable errors -> Show a failure message
                    //   (3) Successful transaction -> Show confirmation or thank you
    
                    // This example reads a v2/checkout/orders capture response, propagated from the server
                    // You could use a different API or structure for your 'orderData'
    
                    const errorDetail = Array.isArray(details.details) && details.details[0];
                    if (errorDetail && errorDetail.issue === 'INSTRUMENT_DECLINED') {
                      return actions.restart(); // Recoverable state, per:
                      // https://developer.paypal.com/docs/checkout/integration-features/funding-failure/
                    }
    
                    if (errorDetail) {
                      let msg = 'Sorry, your transaction could not be processed.';
                      if (errorDetail.description) msg += '
    
            ' + errorDetail.description;
                      if (details.debug_id) msg += ' (' + details.debug_id + ')';
                      return alert(msg); // Show a failure message (try to avoid alerts in production environments)
                    }
    
                    // Successful capture! For demo purposes:
                    console.log('Capture result', details, JSON.stringify(details, null, 2));
                    const transaction = details.purchase_units[0].payments.captures[0];
                    alert('Transaction '+ transaction.status + ': ' + transaction.id + '
    
            See console for all available details');
                  }}
                />
    `
  })
  return buttons
}
export const reactEnableFunding = (fundingSources: string[]) => {
  let buttons = ''
  fundingSources.forEach((funding) => {
    if (fundingSource[funding])
      buttons += `        "enable-funding":"${fundingSource[funding]}",\r\n`
  })
  return buttons
}
export const angularFundingSources = (fundingSources: string[]) => {
  let buttons = ''
  fundingSources.forEach((funding) => {
    buttons += `          <PayPalButtons
                  fundingSource='${fundingSource[funding]}'
    
                  style={{
                    layout: '{{ buttonLayout }}',
                    shape: '{{ buttonStyle }}'
                  }}
                  createOrder={async (data, actions) => {
                    const response = await fetch("http://localhost:9597/orders", {
                      method: "POST"
                    });
                    const details = await response.json();
                    return details.id;
                  }}
                  onApprove={async (data, actions) => {
                    const response = await fetch(\`http://localhost:9597/orders/\${data.orderID}/capture\`, {
                      method: "POST"
                    });
                    const details = await response.json();
                    // Three cases to handle:
                    //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                    //   (2) Other non-recoverable errors -> Show a failure message
                    //   (3) Successful transaction -> Show confirmation or thank you
    
                    // This example reads a v2/checkout/orders capture response, propagated from the server
                    // You could use a different API or structure for your 'orderData'
    
                    const errorDetail = Array.isArray(details.details) && details.details[0];
                    if (errorDetail && errorDetail.issue === 'INSTRUMENT_DECLINED') {
                      return actions.restart(); // Recoverable state, per:
                      // https://developer.paypal.com/docs/checkout/integration-features/funding-failure/
                    }
    
                    if (errorDetail) {
                      let msg = 'Sorry, your transaction could not be processed.';
                      if (errorDetail.description) msg += '
    
            ' + errorDetail.description;
                      if (details.debug_id) msg += ' (' + details.debug_id + ')';
                      return alert(msg); // Show a failure message (try to avoid alerts in production environments)
                    }
    
                    // Successful capture! For demo purposes:
                    console.log('Capture result', details, JSON.stringify(details, null, 2));
                    const transaction = details.purchase_units[0].payments.captures[0];
                    alert('Transaction '+ transaction.status + ': ' + transaction.id + '
    
            See console for all available details');
                  }}
                />
    `
  })
  return buttons
}

export const codePreviewParser = (content: string, params: any) => {
  let code = content

  //Buttons
  let buttons = getSelectedSources(params.buttons)
  let unselectedButtons = getUnselectedSources(buttons)

  code = code.replace(/{{ fundingSources }}/g, buttons.join())

  code = code.replace(
    /{{ unselectedFundingSources }}/g,
    unselectedButtons.join(),
  )
  code = code.replace(
    /{{ unselectedFundingSourcesFull }}/g,
    '&disable-funding=' + unselectedButtons.join(),
  )

  code = code.replace(
    /{{ fundingSources, list }}/g,
    '// EDIT FUNDING SOURCES\r\n        ' +
      fundingOrderMap
        .filter(
          (fundingSource) =>
            buttons.includes(fundingSource) &&
            (params.paymentModel === 'recurring'
              ? fundingSource !== 'paypal.FUNDING.VENMO'
              : true),
        )
        .join(',\r\n        '),
  )
  code = code.replace(
    /{{ createOrderSubscription }}/g,
    orderSubscriptionCode(params.paymentModel),
  )
  code = code.replace(
    /{{ createOrderSubscription,5 }}/g,
    orderSubscriptionCode(params.paymentModel, 4),
  )
  code = code.replace(
    /{{ createOrderSubscription, 5 }}/g,
    orderSubscriptionCode(params.paymentModel, 4),
  )
  code = code.replace(
    /{{ createOrderSubscription_react,7 }}/g,
    orderSubscriptionCode(params.paymentModel, 7, 'react'),
  )
  code = code.replace(
    /{{ createOrderSubscription_react, 7 }}/g,
    orderSubscriptionCode(params.paymentModel, 7, 'react'),
  )
  code = code.replace(
    /{{ createOrderSubscription_react,8 }}/g,
    orderSubscriptionCode(params.paymentModel, 8, 'react'),
  )
  code = code.replace(
    /{{ createOrderSubscription_react, 8 }}/g,
    orderSubscriptionCode(params.paymentModel, 8, 'react'),
  )
  code = code.replace(
    /{{ createOrderSubscription_angular,3 }}/g,
    orderSubscriptionCode(params.paymentModel, 3, 'angular'),
  )

  code = code.replace(
    /{{ fundingSources, list_2 }}/g,
    fundingOrderMap
      .filter(
        (fundingSource) =>
          buttons.includes(fundingSource) &&
          (params.paymentModel === 'recurring'
            ? fundingSource !== 'paypal.FUNDING.VENMO'
            : true),
      )
      .filter(
        (fundingSource) =>
          params.options.find((option: any) => option.name === 'integration')
            .value === 'standard' || fundingSource !== 'paypal.FUNDING.CARD',
      )
      .join(',\r\n    '),
  )
  code = code.replace(
    /{{ fundingSources, inline_list }}/g,
    fundingOrderMap
      .filter(
        (fundingSource) =>
          buttons.includes(fundingSource) &&
          (params.paymentModel === 'recurring'
            ? fundingSource !== 'paypal.FUNDING.VENMO'
            : true),
      )
      .filter(
        (fundingSource) =>
          params.options.find((option: any) => option.name === 'integration')
            .value === 'standard' || fundingSource !== 'paypal.FUNDING.CARD',
      )
      .map((fundingSource) =>
        fundingSource.replace('paypal.FUNDING.', '').toLowerCase(),
      )
      .join(','),
  )

  const unselectedSources = fundingOrderMap
    .filter(
      (fundingSource) =>
        unselectedButtons
          .map((unselectedButton) =>
            unselectedButton
              .toUpperCase()
              .replace('PAYMENT-BUTTONS_', 'paypal.FUNDING.'),
          )
          .includes(fundingSource) &&
        (params.paymentModel === 'recurring'
          ? fundingSource !== 'paypal.FUNDING.VENMO'
          : true),
    )
    .filter(
      (fundingSource) =>
        params.options.find((option: any) => option.name === 'integration')
          .value === 'standard' || fundingSource !== 'paypal.FUNDING.CARD',
    )
    .map((fundingSource) =>
      fundingSource.replace('paypal.FUNDING.', '').toLowerCase(),
    )
    .join(',')

  code = code.replace(
    /{{ unselectedFundingSourcesFull, inline_list }}/g,
    unselectedButtons.length > 0 ? `&disable-funding=${unselectedSources}` : '',
  )
  code = code.replace(
    /{{ unselectedFundingSources, inline_list }}/g,
    unselectedSources,
  )

  code = code.replace(
    /{{ fundingSources,short_list_2 }}/g,
    fundingOrderMap
      .filter(
        (fundingSource) =>
          buttons.includes(fundingSource) &&
          (params.paymentModel === 'recurring'
            ? fundingSource !== 'paypal.FUNDING.VENMO'
            : true),
      )
      .map((fundingSource) => fundingSource.replace('paypal.', ''))
      .join(',\r\n    '),
  )
  code = code.replace(
    /{{ fundingSources, html }}/g,
    htmlFundingSources(params.buttons),
  )
  code = code.replace(
    /{{ fundingSources, react }}/g,
    reactFundingSources(params.buttons),
  )
  code = code.replace(
    /{{ enableFunding, react }}/g,
    reactEnableFunding(params.buttons),
  )

  Object.keys(params).forEach((param) => {
    const paramType = typeof params[param]
    let paramValue: string = ''

    switch (paramType) {
      case 'object':
        paramValue = JSON.stringify(params[param])
        if (Array.isArray(params[param])) {
          switch (param) {
            case 'buttons':
              break
            default:
              paramValue = params[param].join()
              break
          }
        }
        break
      default:
        paramValue = params[param]
        break
    }
    const regex = new RegExp(`{{ ${param} }}`, 'g')

    code = code.replace(regex, paramValue)
  })
  return code
}
